/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx, keyframes } from '@emotion/react';
import { useRef } from 'react';
var pulseKeyframes = keyframes({
  to: {
    boxShadow: '0 0 0 7px rgba(0, 0, 0, 0)'
  }
});
var pulseStyles = css({
  borderRadius: '3px',
  boxShadow: "0 0 0 0 ".concat("var(--ds-background-discovery-bold, #5243AA)"),
  animation: "".concat(pulseKeyframes, " 1.45s cubic-bezier(0.5, 0, 0, 1) 3")
});
var commonStyles = css({
  display: 'inline'
});
export var Pulse = function Pulse(_ref) {
  var children = _ref.children,
    _ref$showPulse = _ref.showPulse,
    showPulse = _ref$showPulse === void 0 ? false : _ref$showPulse,
    onAnimationIteration = _ref.onAnimationIteration,
    onAnimationStart = _ref.onAnimationStart,
    testId = _ref.testId;
  // this ref is to persist the animation through rerenders
  var pulseStarted = useRef(false);
  if (showPulse) {
    pulseStarted.current = true;
  }
  var stopPropagation = function stopPropagation(e) {
    e.stopPropagation();
  };
  return jsx("div", {
    "data-testid": testId !== null && testId !== void 0 ? testId : 'discovery-pulse',
    css: [commonStyles, pulseStarted.current && pulseStyles],
    onAnimationIteration: onAnimationIteration,
    onAnimationStart: onAnimationStart
  }, jsx("span", {
    onAnimationIteration: stopPropagation,
    onAnimationStart: stopPropagation
  }, children));
};
export default Pulse;